import { defineStore } from 'pinia';
import { ref } from 'vue';
import { marketplaceService } from '@/connect/services/marketplace';
import { useSocketStore } from '@/store/socket-store';
import { throttle } from 'lodash';

export const useSidebarNotificationsStore = defineStore('sidebar-notifications', () => {
  const notifications = ref({
    executions: 0,
  });

  async function fetchOmsUnackedExecutions() {
    const result = await marketplaceService.queryExecutions({
      pageNumber: -1,
      pageLimit: -1,
    });
    if (result.success) {
      updateOmsUnackedExecutions(
        result.data.execRecs.filter((execution) => !execution.acknowledgedAt).length
      );
    }
  }

  function updateOmsUnackedExecutions(unackedCount: number) {
    notifications.value.executions = unackedCount;
  }

  const fetchOmsUnackedExecutionsThrottled = throttle(fetchOmsUnackedExecutions, 2000, {
    leading: false,
    trailing: true, // because we want the most recent data
  });

  const socketStore = useSocketStore();
  socketStore.useEventHandler('refreshOmsUnackedExecutions', fetchOmsUnackedExecutionsThrottled);
  // every time the socket (re)connects we re-fetch the executions count (including on first time)
  socketStore.onOpen(fetchOmsUnackedExecutions);

  function getNotifications() {
    return notifications.value;
  }

  return {
    getNotifications,
  };
});

export type SidebarNotificationsStore = ReturnType<typeof useSidebarNotificationsStore>;
